import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from "common/toast";
import DropdownPoolOption from "components/Common/DropdownPoolOption";
import LabelWrapper from "components/Common/LabelWrapper";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Col, Input, Label, Modal, ModalBody, ModalHeader, Row, Spinner } from "reactstrap";
import { postWallet, putWallet } from "store/thunks";
import * as Yup from "yup";
export interface Props {
    isOpen?: boolean;
    detail?: any | null,
    listPool: any[],
    onClose?: () => void
    triggerRefresh?: (type?: string) => void;
}

const WallerForm = ({
    isOpen = false,
    detail = null,
    listPool = [],
    onClose,
    triggerRefresh
}: Props) => {
    const { t } = useTranslation();

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const OPTION_POOLS = listPool;

    const [poolSelect, setPoolSelect] = useState<any>(null);

    const ORCA_MIN_SQRT_PRICE_X64 = "4295048016";
    const ORCA_MAX_SQRT_PRICE_X64 = "79226673515401279992447579055";

    const onCloseClick = () => {
        onClose && onClose();
    }
    const handleSubmit = async (values: any) => {
        try {
            setIsLoading((_prev) => true);
            const amountIn = Boolean(poolSelect?.data?.aTob) ? Number(values?.amount_from) : Number(values?.amount_to);
            const amountThreshold = Boolean(poolSelect?.data?.aTob) ? Number(values?.amount_to) : Number(values?.amount_from);

            const data = {
                pool: poolSelect?.value || '',
                amountIn: Number(amountIn) * Math.pow(10, Number(Boolean(poolSelect?.data?.aTob) ? Number(poolSelect?.data?.tokenDecimals1) : Number(poolSelect?.data?.tokenDecimals2))),
                amountThreshold: Number(amountThreshold) * Math.pow(10, Number(Boolean(poolSelect?.data?.aTob) ? Number(poolSelect?.data?.tokenDecimals2) : Number(poolSelect?.data?.tokenDecimals1))),
                aTob: Boolean(poolSelect?.data?.aTob),
                sqrtPriceStr: values?.sqrtPriceStr || ''
            };
            const response: any = !!detail?.id ? await putWallet(detail?.id, data) : await postWallet(data);
            if (response?.data) {
                setIsLoading((_prev) => false);
                toast(
                    <div>
                        {t("The process has been completed.")} -
                        <a href={`https://solscan.io/tx/${Array.isArray(response?.data) ? response?.data?.[0] : (response?.data || '')}`} className="text-primary text-decoration-underline" target="_blank" rel="noopener noreferrer">TX</a>
                    </div>,
                    CONFIG_OPTION_TOAST_NORMAL
                );
                onCloseClick();
                // triggerRefresh && triggerRefresh();
            } else {
                setIsLoading((_prev) => false);
                toast(`${response || 'Error - Plz try again!'}`, CONFIG_OPTION_TOAST_ERROR);
            }
        } catch (error: any) {
            setIsLoading((_prev) => false);
            toast(`${error?.message || 'Error - Plz try again!'}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    };

    const validationSchema = Yup.object({
        amount_from: Yup.string().required(`${t("This is required")}`),
        address_from: Yup.string().required(`${t("This is required")}`),
        amount_to: Yup.string().required(`${t("This is required")}`),
        address_to: Yup.string().required(`${t("This is required")}`),
        aTob: Yup.boolean().nullable(),
        sqrtPriceStr: Yup.string().required(`${t("This is required")}`),
    });

    const formik = useFormik({
        initialValues: {
            amount_from: '',
            address_from: '',
            amount_to: '',
            address_to: '',
            aTob: false,
            sqrtPriceStr: ''
        },
        validationSchema,
        onSubmit: handleSubmit,
    });

    useEffect(() => {
        const handleCallAllOption = async () => {
            try {
                const _amount_from = detail?.amount_from || '';
                const _address_from = detail?.address_from || '';
                const _amount_to = detail?.amount_to || '';
                const _address_to = detail?.address_to || '';

                const _aTob = detail?.aTob || '';
                const _sqrtPriceStr = Boolean(poolSelect?.data?.aTob) ? ORCA_MIN_SQRT_PRICE_X64 : ORCA_MAX_SQRT_PRICE_X64;

                formik.setFieldValue('amount_from', _amount_from);
                formik.setFieldValue('address_from', _address_from);
                formik.setFieldValue('amount_to', _amount_to);
                formik.setFieldValue('address_to', _address_to);

                formik.setFieldValue('aTob', _aTob);
                formik.setFieldValue('sqrtPriceStr', _sqrtPriceStr);

                setTimeout(() => {
                    formik.setErrors({});
                }, 300);
            } catch (error: any) {
                // setIsLoadingDetail((_prev) => false);
                return error;
            }
        };
        handleCallAllOption();
    }, [JSON.stringify(detail)]);


    const handleChangeAtoB = () => {
        if (!poolSelect?.value) {
            return;
        }
        setPoolSelect((_prev: any) => {
            formik.setFieldValue('sqrtPriceStr', Boolean(!_prev?.data?.aTob) ? ORCA_MIN_SQRT_PRICE_X64 : ORCA_MAX_SQRT_PRICE_X64);
            return ({
                ..._prev,
                data: {
                    ..._prev?.data,
                    aTob: !_prev?.data?.aTob,
                    // logo1: _prev?.data?.logo2,
                    // logo2: _prev?.data?.logo1,
                    // tokenSymbol1: _prev?.data?.tokenSymbol2,
                    // tokenSymbol2: _prev?.data?.tokenSymbol1,
                    // tokenAddress1: _prev?.data?.tokenAddress2,
                    // tokenAddress2: _prev?.data?.tokenAddress1,
                    // tokenDecimals1: _prev?.data?.tokenDecimals2,
                    // tokenDecimals2: _prev?.data?.tokenDecimals1,
                }
            });
        });

    };

    return (
        <React.Fragment>
            <Modal
                isOpen={isOpen}
                centered={true}
                size="md"
                // className={`border-header-footer`}
                scrollable={false}
                toggle={onCloseClick}
                keyboard={true}
            >
                <ModalHeader toggle={onCloseClick} className="modal-title-flex-grow-1 pb-3 border border-dashed border-end-0 border-start-0 border-top-0">
                    <div className="d-flex flex-column gap-0 gap-sm-2 fs-18 fs-md-20">
                        <div className="flex-grow-1">
                            <>{!!detail?.id ? t('Update Wallet') : t('Create Swap')}</>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody className="position-relative">
                    <div>
                        <form onSubmit={formik.handleSubmit}>
                            <Row>
                                <Col sm={12}
                                    md={6}
                                    xl={12}
                                    xxl={12}
                                    className="mt-2 mb-2"
                                >
                                    <LabelWrapper label={t('Label_Pool')} isShow={true}>
                                        <DropdownPoolOption
                                            isMultiLang
                                            name="pool"
                                            dataList={OPTION_POOLS}
                                            initialValue={poolSelect || null}
                                            onChangeSelect={(event: any) => {
                                                setPoolSelect((_prev: any) => event);
                                                formik.setFieldValue('address_from', event?.data?.tokenAddress1 || '');
                                                formik.setFieldValue('address_to', event?.data?.tokenAddress2 || '');
                                            }}
                                            className="dropdown-status-rounded z-hight"
                                            classNamePrefix="name-prefix"
                                            isShowMore={true}
                                            // className="bg-[#fff]"
                                            labelTop=""
                                            isHasOptionAll={true}
                                            optionAll={{
                                                label: t('None'),
                                                value: ''
                                            }}
                                        />
                                    </LabelWrapper>
                                </Col>
                                <Col sm={12} lg={12} className="mt-2 mb-3">
                                    <LabelWrapper label={t('sqrtPriceStr')} isShow={true}>
                                        <Input
                                            name="sqrtPriceStr"
                                            type="text"
                                            className="form-control"
                                            id="sqrtPriceStr"
                                            placeholder={t('sqrtPriceStr')}
                                            value={formik?.values?.sqrtPriceStr || ''}
                                            // disabled={true}
                                            onChange={(event: any) => formik.setFieldValue('sqrtPriceStr', event?.target?.value)}
                                        />
                                    </LabelWrapper>
                                    {formik.touched.sqrtPriceStr && formik.errors.sqrtPriceStr ? (
                                        <div className="text-danger mt-2">{formik.errors.sqrtPriceStr}</div>
                                    ) : null}
                                </Col>
                                <div className={`d-flex position-relative gap-2 ${(!!poolSelect?.data?.aTob && !!poolSelect?.value) ? 'flex-column' : 'flex-column-reverse'}`}>
                                    <div className="position-absolute bg-primary-subtle cursor-pointer" style={{
                                        left: '50%',
                                        top: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        fontSize: '22px',
                                        // backgroundColor: '#9ed0fd',
                                        border: '1px solid var(--vz-primary)',
                                        width: '30px',
                                        height: '30px',
                                        textAlign: 'center',
                                        borderRadius: '4px',
                                        zIndex: '3'
                                    }}
                                        onClick={() => handleChangeAtoB()}
                                    >
                                        <i className="bx bx-sort-alt-2 text-primary" />
                                    </div>
                                    <div
                                        style={{
                                            borderRadius: '10px',
                                            padding: '20px 20px',
                                        }}
                                        className="bg-primary-subtle"
                                    >
                                        <Row>
                                            <Col sm={12} lg={12} className="mb-3">
                                                <Label htmlFor="amount_from" className="form-label">{Boolean(poolSelect?.data?.aTob) ? t('Amount In') : t('Amount Out')} <span className="text-danger"> *</span></Label>
                                                <div className="position-relative">
                                                    <Input
                                                        name="amount_from"
                                                        type="text"
                                                        className="form-control"
                                                        id="amount_from"
                                                        placeholder={Boolean(poolSelect?.data?.aTob) ? t('Amount In') : t('Amount Out')}
                                                        value={formik?.values?.amount_from}
                                                        onChange={(event: any) => {
                                                            const input = event.target.value;
                                                            const onlyNumbers = input.replace(/[^0-9.]/g, "");
                                                            const s = onlyNumbers;
                                                            formik.setFieldValue("amount_from", s);
                                                        }}
                                                    />
                                                    <div
                                                        style={{ bottom: 10, right: 20 }}
                                                        className="position-absolute fw-medium text-secondary"
                                                    >
                                                        {poolSelect?.data?.tokenSymbol1 || ''}
                                                    </div>
                                                </div>

                                                {formik.touched.amount_from && formik.errors.amount_from ? (
                                                    <div className="text-danger mt-2">{formik.errors.amount_from}</div>
                                                ) : null}
                                            </Col>

                                            <Col sm={12} lg={12} className="mb-2">
                                                <Label htmlFor="address_from" className="form-label">{t('Address')} <span className="text-danger"> *</span></Label>
                                                <Input
                                                    name="address_from"
                                                    type="text"
                                                    className="form-control"
                                                    id="address_from"
                                                    placeholder={t('Address')}
                                                    disabled={!!poolSelect?.value}
                                                    value={formik?.values?.address_from}
                                                    onChange={(event: any) => formik.setFieldValue('address_from', event?.target?.value)}
                                                />
                                                {formik.touched.address_from && formik.errors.address_from ? (
                                                    <div className="text-danger mt-2">{formik.errors.address_from}</div>
                                                ) : null}
                                            </Col>
                                        </Row>
                                    </div>
                                    <div
                                        className="bg-primary-subtle"
                                        style={{
                                            borderRadius: '10px',
                                            padding: '20px 20px',
                                        }}
                                    >
                                        <Row>
                                            <Col sm={12} lg={12} className="mb-3">
                                                <Label htmlFor="amount_to" className="form-label">{Boolean(poolSelect?.data?.aTob) ? t('Amount Out') : t('Amount In')} <span className="text-danger"> *</span></Label>
                                                <div className="position-relative">
                                                    <Input
                                                        name="amount_to"
                                                        type="text"
                                                        className="form-control"
                                                        id="amount_to"
                                                        placeholder={Boolean(poolSelect?.data?.aTob) ? t('Amount Out') : t('Amount In')}
                                                        value={formik?.values?.amount_to}
                                                        onChange={(event: any) => {
                                                            const input = event.target.value;
                                                            const onlyNumbers = input.replace(/[^0-9.]/g, "");
                                                            const s = onlyNumbers;
                                                            formik.setFieldValue("amount_to", s);
                                                        }}
                                                    />
                                                    <div
                                                        style={{ bottom: 10, right: 20 }}
                                                        className="position-absolute fw-medium text-secondary"
                                                    >
                                                        {poolSelect?.data?.tokenSymbol2 || ''}
                                                    </div>
                                                </div>
                                                {formik.touched.amount_to && formik.errors.amount_to ? (
                                                    <div className="text-danger mt-2">{formik.errors.amount_to}</div>
                                                ) : null}
                                            </Col>

                                            <Col sm={12} lg={12} className="mb-2">
                                                <Label htmlFor="address_to" className="form-label">{t('Address')} <span className="text-danger"> *</span></Label>
                                                <Input
                                                    name="address_to"
                                                    type="text"
                                                    className="form-control"
                                                    id="address_to"
                                                    placeholder={t('Address')}
                                                    disabled={!!poolSelect?.value}
                                                    value={formik?.values?.address_to}
                                                    onChange={(event: any) => formik.setFieldValue('address_to', event?.target?.value)}
                                                />
                                                {formik.touched.address_to && formik.errors.address_to ? (
                                                    <div className="text-danger mt-2">{formik.errors.address_to}</div>
                                                ) : null}
                                            </Col>
                                        </Row>
                                    </div>
                                </div>

                                <Col sm={12} className="mb-2 mt-3" >
                                    <div className="d-flex gap-3 justify-content-end align-item-center">
                                        <button
                                            className="btn btn-primary fs-14 px-1 d-flex justify-content-center align-item-center bg-[#009ef7] hover:bg-[#0086d2]"
                                            type="submit"
                                            style={{ width: '150px' }}
                                            disabled={isLoading}
                                        >
                                            {isLoading && <span style={{ transform: 'translateY(1px)' }} className="me-1"><Spinner size="sm"></Spinner></span>}<span>{
                                                !!detail?.id ? t('Update Wallet') : t('Create Swap')
                                            }</span>
                                        </button>
                                        <button
                                            className="btn btn-secondary fs-14 px-1 d-flex justify-content-center align-item-center bg-[#878a99] hover:bg-[#737582]"
                                            type="button"
                                            onClick={onCloseClick}
                                            style={{ width: '75px' }}
                                        >
                                            <span className="ms-1">{t("Button Close")}</span>
                                        </button>
                                    </div>
                                </Col>
                            </Row>
                        </form>
                    </div>
                </ModalBody>
            </Modal>
        </React.Fragment >
    );
};

export default WallerForm;

